import {forwardRef} from 'external/react'
import {
    styled,
    clsx,
    AppBar,
    Box,
    Dialog,
    ToolBar,
    IconButton,
    CloseIcon,
    Slide
 } from 'external/material';

const Transition = forwardRef((props, ref) => (<Slide direction="up" ref={ref} {...props} />))


export default function FullScreenDialog(props) {

    const {
        open,
        title,
        closePosition = 'start',
        className,
        handleClose,
        children
    } = props

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            className={clsx('dialog-root', className)}
            TransitionComponent={Transition}
            fullScreen
            disableEscapeKeyDown
        >
                    <IconButton
                        sx={{position: 'fixed', right: 6, top: 6}}
                        edge={closePosition}
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                        className="dialog-close-button"
                    >
                        <CloseIcon />
                    </IconButton>

        {children}
    </Dialog>
    )
}
